import { render, staticRenderFns } from "./PgaTimeLine.vue?vue&type=template&id=31a0576a&"
import script from "./PgaTimeLine.vue?vue&type=script&lang=ts&"
export * from "./PgaTimeLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VRow,VTimeline,VTimelineItem})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a0576a')) {
      api.createRecord('31a0576a', component.options)
    } else {
      api.reload('31a0576a', component.options)
    }
    module.hot.accept("./PgaTimeLine.vue?vue&type=template&id=31a0576a&", function () {
      api.rerender('31a0576a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaTimeLine.vue"
export default component.exports